import { currentCsrfToken } from './csrf-token.js';

function createQrPayCore() {
    const POLL_MS = 1100;
    const TICK_MS = 1000;
    const COUNTDOWN_START = 10;
    const MAX_LIFETIME_SECS = 300;

    function create() {
        let callbacks = null;
        let state = emptyState();

        function emptyState() {
            return {
                qrId: null,
                polling: false,
                countdown: null,
                counting: false,
                lifetimeSecs: 0,
                openInterval: null,
                closeInterval: null,
            };
        }

        function reset() {
            clearInterval(state.openInterval);
            clearInterval(state.closeInterval);
            state = emptyState();
            callbacks = null;
        }

        function pollOpened() {
            if (!state.polling) return;
            $.ajax({
                url: callbacks.checkUrl,
                type: 'POST',
                data: { qr_code_id: state.qrId, _token: currentCsrfToken() },
                success: function (res) {
                    if (!res.success) return;
                    state.polling = false;
                    state.counting = true;
                    state.countdown = COUNTDOWN_START;
                    callbacks.onScanned?.();
                },
                error: function (jqXHR, textStatus) {
                    console.error('qr-pay-core: poll request failed', textStatus);
                },
            });
        }

        function tick() {
            if (state.qrId === null) return;
            if (state.countdown === 0) {
                const onComplete = callbacks.onComplete;
                reset();
                onComplete?.();
                return;
            }
            if (state.counting) {
                callbacks.onTick?.(state.countdown);
                state.countdown--;
                return;
            }
            state.lifetimeSecs++;
            if (state.lifetimeSecs >= MAX_LIFETIME_SECS) {
                const onExpired = callbacks.onExpired;
                reset();
                onExpired?.();
            }
        }

        function start(opts) {
            callbacks = opts;

            $.ajax({
                type: 'POST',
                url: opts.saveUrl,
                data: Object.assign({ _token: currentCsrfToken() }, opts.donationData),
                success: function (data) {
                    if (!data.success) {
                        opts.onError?.(data.error || '');
                        return;
                    }
                    state.qrId = data.qr_code_id;
                    state.polling = true;
                    state.countdown = COUNTDOWN_START;
                    state.openInterval = setInterval(pollOpened, POLL_MS);
                    state.closeInterval = setInterval(tick, TICK_MS);
                    opts.onQrReady?.(data.qr_code, data.qr_code_url);
                },
                error: function () {
                    opts.onError?.('');
                },
            });
        }

        function stop() {
            reset();
        }

        return { start, stop };
    }

    return { create: create };
}

const QrPayCore = createQrPayCore();

export default QrPayCore;
